"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const luxon_1 = require("luxon");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const budgetsSelectors_1 = require("companion-app-components/flux/budgets/budgetsSelectors");
const AmountField_1 = require("components/QuickenControls/AmountField");
const progressChart_1 = __importDefault(require("./progressChart"));
const styles_1 = __importDefault(require("./styles"));
const utils_1 = require("./utils");
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const AnnualSpendingChart = ({ budgetId }) => {
    const { classes, theme } = useStyles();
    const data = (0, react_redux_1.useSelector)((state) => (0, budgetsSelectors_1.getAnnualSpendings)(state, budgetId));
    const budget = (0, react_redux_1.useSelector)((state) => (0, budgetsSelectors_1.getBudgetById)(state, budgetId));
    const { startDate, endDate, totalSpendings, annualBudget, totalSavings, currency } = data;
    const amountFormat = (budget === null || budget === void 0 ? void 0 : budget.showCents) ? '0,00.00' : '0,0';
    const dataForChart = (0, react_1.useMemo)(() => (0, utils_1.generateChartData)(totalSpendings, annualBudget, totalSavings, currency, theme, amountFormat), [totalSpendings, annualBudget, totalSavings, currency, theme, amountFormat]);
    if (totalSpendings > 0 || annualBudget > 0 || totalSavings > 0) {
        return (<Paper_1.default className={classes.progressWrapper}>
        <Typography_1.default className={classes.rangeHeader}>
          {luxon_1.DateTime.fromISO(startDate).toFormat('MMM yyyy')} - {luxon_1.DateTime.fromISO(endDate).toFormat('MMM yyyy')}
        </Typography_1.default>
        <div className={classes.budgetAmountWrapper}>
          <Typography_1.default>
            Spending {(0, AmountField_1.formatNumber)(totalSpendings, currency, amountFormat)} of {(0, AmountField_1.formatNumber)(annualBudget, currency, amountFormat)}
          </Typography_1.default>
          {totalSavings > 0 && (<Typography_1.default>
              Savings {(0, AmountField_1.formatNumber)(totalSavings, currency, amountFormat)}
            </Typography_1.default>)}
        </div>
        <progressChart_1.default data={dataForChart}/>
      </Paper_1.default>);
    }
    return null;
};
exports.default = AnnualSpendingChart;
